<template>
  <ul id="tabs" class="nav nav-tabs">
    <li class="nav-item">
      <router-link
        :to="{ name: 'profile.ongoing-orders' }"
        class="nav-link"
        :class="{ 'active show': $route.name === 'profile.ongoing-orders' }"
      >
        {{ _T('Ongoing') }}
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'profile.scheduled-orders' }"
        class="nav-link"
        :class="{
          'active show': $route.name === 'profile.scheduled-orders',
        }"
      >
        {{ _T('Scheduled') }}
      </router-link>
    </li>
    <li class="nav-item" v-if="windowSize <= 575">
      <router-link
        :to="{ name: 'profile.history' }"
        class="nav-link"
        :class="{
          'active show': $route.name === 'profile.history',
        }"
      >
        {{ _T('Past') }}
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import Windowsize from '@/mixins/Windowsize'
export default {
  name: 'OrderTabs',
  mixins: [Windowsize],
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.nav-tabs {
  border: $px1 solid $light-border !important;
  border-radius: $px4;
  display: inline-block;
  position: absolute;
  top: $px9;
  right: $px30;

  .nav-item {
    margin-bottom: 0;

    &.show {
      .nav-link {
        background-color: $light-border;
        transition: 0.5s ease;
      }
    }
  }

  .nav-link {
    border: none;
    line-height: $px22;
    letter-spacing: 0.5px;
    color: $light-font;
    border-radius: 0;
    transition: 0.5s ease;

    &.active {
      background-color: $light-border;
      font-weight: 600;
      color: $font-color;
      transition: 0.5s ease;
    }
  }
}
@media (max-width: 991px) {
  .nav-tabs {
    right: $px20;
  }
}
@media (max-width: 575px) {
  .nav-tabs {
    position: relative;
    top: unset;
    right: 0;
    margin: $px15 $px20;
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    .nav-item {
      width: 100%;
      text-align: center;
      a {
        height: 100%;
        width: 100%;
      }
    }
    .nav-link {
      &.active {
        background-color: $warning-color;
        color: $white;
      }
    }
  }
}
.body-rtl {
  ul {
    padding-right: 0;
    left: 0;
    right: unset;
  }
}
</style>
